import { GameModeConfig, GameMode } from '../types';

// Import all objects and helper functions from the dedicated objects file
export { 
  gameObjects, 
  getObjectById, 
  getObjectsWithMeasurement, 
  getObjectsByDifficulty,
  getAllObjects,
  getObjectsBySize
} from './objects';

/**
 * Game Mode Configurations
 * 
 * Defines the available game modes and their settings.
 */
export const gameModeConfigs: GameModeConfig[] = [
  {
    id: 'classic',
    name: 'Classic',
    description: 'Standard 10 questions with mixed measurements',
    icon: '🎯',
    settings: {
      totalQuestions: 10,
      measurementType: 'mixed'
    }
  },
  {
    id: 'timed',
    name: 'Timed Challenge',
    description: 'Answer as many as you can in 3 minutes',
    icon: '⏱️',
    settings: {
      timeLimit: 180,
      measurementType: 'mixed'
    }
  },
  {
    id: 'endless',
    name: 'Endless Mode',
    description: 'Keep playing until you want to stop',
    icon: '♾️',
    settings: {
      measurementType: 'mixed'
    }
  },
  {
    id: 'measurement_focus',
    name: 'Measurement Focus',
    description: 'Focus on one type: length, weight, or volume',
    icon: '📏',
    settings: {
      totalQuestions: 10,
      measurementType: 'length' // Will be selectable
    }
  },
  {
    id: 'power_ups',
    name: 'Power-Ups Mode',
    description: 'Endless mode with special power-ups and 5 lives',
    icon: '⚡',
    settings: {
      measurementType: 'mixed',
      lives: 5
    }
  },
  {
    id: 'streak_master',
    name: 'Streak Master',
    description: 'Build the longest streak possible',
    icon: '🔥',
    settings: {
      measurementType: 'mixed',
      streakTarget: 10
    }
  }
];

export const getGameModeConfig = (gameMode: GameMode): GameModeConfig | undefined => {
  return gameModeConfigs.find(config => config.id === gameMode);
}; 